import { CheckCircleOutlined, Delete, Edit } from '@mui/icons-material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
    Box,
    Breadcrumbs,
    Button,
    CircularProgress,
    Dialog,
    DialogContent,
    Divider,
    Grid,
    Menu,
    MenuItem,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { SUPPLIER_INVOICE_STATUS_COLOR } from '../../../../App';
import CommonDialog from '../../../../common/CommonDialog';
import { clearSupplierInvoiceDetail, deleteSupplierInvoiceApi, getSupplierInvoiceDetail } from '../../../../redux/Supplier/action';
import { INVENTORY_TYPES } from '../../../../utility/Constant';
import { NumericEngine } from '../../../../utility/helpers/numericEngine';
import BrandSvg from '../../../../utility/Svg/BrandSvg';
import PartCategorySvg from '../../../../utility/Svg/PartCategorySvg';
import { formatPhoneNumber } from '../../../Common/FormatPhoneNumber';
import SuccessMessageModal from '../../../Common/SuccessMessage';
import AddInventoryModal from '../../../Inventory/AddInventory';
import BatchViewModal from '../../../Inventory/BatchViewModal';
import PartUsedInvoiceModal from '../PartUsedInvoiceModal';
import './SupplierSent.css';
import { toast } from 'sonner';

const SupplierSent = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const [batchNumber, setBatchNumber] = useState(null);

    const [showLoader, setShowLoader] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
    const [openSuccessModal, setOpenSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    const [selectedInventoryId, setSelectedInventoryId] = useState(null);
    const [selectSupplierInvoiceId, setSupplierInvoiceId] = useState(null);
    const [openPartModel, setOpenpartModel] = useState(false);

    const [partInvoiceModal, setPartInvoiceModal] = useState(false);

    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);

    const [openBatchSelectionModal, setBatchSelectionModal] = useState(false);
    const [inventoryOption, setInventoryOption] = useState(null);

    const handleClickMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose1 = () => {
        setAnchorEl(null);
    };

    const [openModal, setOpenModal] = useState(false);

    const supplierInvoiceDetail = useSelector((state) => state.supplier?.supplierInvoiceDetail?.data);
    const isUsedInCustomerInvoice = supplierInvoiceDetail?.parts?.some((part) => part.isUsedInCustomerInvoice === true);

    const fetchSupplierInvoiceDetail = async () => {
        setShowLoader(true);
        await dispatch(getSupplierInvoiceDetail(id));
        setShowLoader(false);
    };

    useEffect(() => {
        fetchSupplierInvoiceDetail();

        return () => {
            dispatch(clearSupplierInvoiceDetail());
        };
    }, []);

    const handlePrintPdf = () => {
        // Assuming supplierInvoiceDetail.pdfurl contains the URL of the PDF
        const pdfUrl = supplierInvoiceDetail?.pdfUrl;

        // Open a new window or tab to print the PDF
        window.open(pdfUrl, '_blank');

        // Close the menu
        handleClose1();
    };

    const clickDownload = async () => {
        try {
            // Fetch the file content
            const fileResponse = await fetch(supplierInvoiceDetail?.pdfUrl);
            const fileBlob = await fileResponse.blob();

            // Create a download link
            const url = window.URL.createObjectURL(fileBlob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'downloaded_file.pdf');

            // Append the link to the body, trigger a click, and remove the link
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Release the object URL
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    };
    const handleSend = async () => {
        setShowLoader(true);
        const data = await dispatch(id);
        if (data) {
            setOpenSuccessModal(true);
            fetchSupplierInvoiceDetail();
            handleClose1();
            setTimeout(() => {
                toast.success('Invoice was successfully emailed to customer');
            }, 400);
        }
    };

    return (
        <Box>
            <Box
                padding={'32px 24px'}
                sx={{
                    bgcolor: 'background.main',
                    width: 'fit-content',
                    minWidth: '100%',
                }}
            >
                {' '}
                <Grid container sx={{ padding: '16px 0px' }} gap={'8px'}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <div
                            role="presentation"
                            onClick={(event) => {
                                event.preventDefault();
                            }}
                        >
                            <Breadcrumbs aria-label="breadcrumb">
                                <Link
                                    to="/suppliers-invoice/all"
                                    style={{
                                        color: ' rgba(0, 0, 0, 0.60)',
                                        fontSize: 16,
                                        fontWeight: 400,
                                        lineHeight: '24px',
                                        letterSpacing: '0.15px',
                                        textDecoration: 'none',
                                    }}
                                >
                                    Supplier Invoices
                                </Link>
                                <Link
                                    to={`/suppliers-invoice/${
                                        supplierInvoiceDetail?.paymentStatus === 'open'
                                            ? 'Open'
                                            : supplierInvoiceDetail?.paymentStatus === 'partial_payment'
                                              ? 'Partially Paid'
                                              : 'Paid'
                                    }`}
                                    style={{
                                        color: ' rgba(0, 0, 0, 0.60)',
                                        fontSize: 16,
                                        fontWeight: 400,
                                        lineHeight: '24px',
                                        letterSpacing: '0.15px',
                                        textDecoration: 'none',
                                    }}
                                >
                                    {supplierInvoiceDetail?.paymentStatus === 'open'
                                        ? 'Open'
                                        : supplierInvoiceDetail?.paymentStatus === 'partial_payment'
                                          ? 'Partially Paid'
                                          : 'Paid'}
                                </Link>
                                <Link
                                    to={`/suppliers-invoice/created/${id}`}
                                    style={{
                                        color: ' rgba(0, 0, 0, 0.60)',
                                        fontSize: 16,
                                        fontWeight: 400,
                                        lineHeight: '24px',
                                        letterSpacing: '0.15px',
                                        textDecoration: 'none',
                                    }}
                                >
                                    {supplierInvoiceDetail?.invoiceNumber}
                                </Link>
                            </Breadcrumbs>
                        </div>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="h4" sx={{ fontWeight: '500' }}>
                            {supplierInvoiceDetail?.invoiceNumber}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={2} justifyContent="end">
                    <Grid item>
                        <Stack direction={'row'} spacing={2}>
                            <Button
                                variant="contained"
                                color="secondary"
                                className="btn-text-size-manage"
                                startIcon={<VisibilityIcon />}
                                style={{
                                    fontWeight: 500,
                                    lineHeight: '24px',
                                    letterSpacing: '0.04px',
                                    fontSize: '14px',
                                }}
                                onClick={() => {
                                    navigate(`/suppliers/${supplierInvoiceDetail?.supplier?._id}`);
                                }}
                            >
                                View Supplier
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<Edit />}
                                onClick={() => {
                                    navigate(`/suppliers-invoice/${supplierInvoiceDetail?._id}`);
                                }}
                                style={{
                                    fontWeight: 500,
                                    lineHeight: '24px',
                                    letterSpacing: '0.04px',
                                    fontSize: '14px',
                                }}
                            >
                                Edit INVOICE
                            </Button>
                            <Button
                                variant="contained"
                                color="secondary"
                                id="demo-positioned-button"
                                aria-controls={openMenu ? 'demo-positioned-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={openMenu ? 'true' : undefined}
                                onClick={handleClickMenu}
                                size="large"
                                style={{
                                    fontWeight: 500,
                                    lineHeight: '24px',
                                    letterSpacing: '0.04px',
                                    fontSize: '14px',
                                    background: '#0000001A',
                                    color: '#000000',
                                    boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25)',
                                }}
                            >
                                more actions
                            </Button>
                            <Menu
                                id="demo-positioned-menu"
                                aria-labelledby="demo-positioned-button"
                                anchorEl={anchorEl}
                                open={openMenu}
                                onClose={() => setAnchorEl(null)}
                            >
                                <MenuItem
                                    onClick={() => {
                                        navigate(`/suppliers/${supplierInvoiceDetail?.supplier?._id}`);
                                    }}
                                >
                                    <VisibilityIcon style={{ marginRight: '10px' }} />
                                    View Supplier
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        setIsOpenDeleteModal(true);
                                        setAnchorEl(null);
                                    }}
                                >
                                    <Delete style={{ marginRight: '10px' }} /> Delete Invoice
                                </MenuItem>
                            </Menu>
                        </Stack>
                    </Grid>
                </Grid>
                <Grid container padding={'24px'} margin={'32px 0'} boxShadow={2} gap={2} sx={{ bgcolor: 'white' }}>
                    <Grid container item spacing={2} justifyContent="space-between">
                        <Grid item style={{ color: 'white' }} lg={12} md={12} sm={12} xs={12} xl={12}>
                            <Stack
                                direction={'row'}
                                spacing={2}
                                style={{
                                    backgroundColor: SUPPLIER_INVOICE_STATUS_COLOR[supplierInvoiceDetail?.paymentStatus],
                                    color: 'black',
                                    height: '52px',
                                }}
                                alignItems={'center'}
                                padding={'8px 8px'}
                                borderRadius={'4px'}
                            >
                                <Stack>
                                    <CheckCircleOutlined />
                                </Stack>
                                <Stack direction={'column'} spacing={0}>
                                    <Typography variant="title" sx={{ fontWeight: 500 }}>
                                        {supplierInvoiceDetail?.paymentStatus === 'open'
                                            ? 'Open'
                                            : supplierInvoiceDetail?.paymentStatus === 'partial_payment'
                                              ? 'Partially Paid'
                                              : 'Paid'}
                                    </Typography>
                                </Stack>
                            </Stack>
                        </Grid>
                    </Grid>
                    <Grid container item spacing={2} justifyContent="space-between">
                        <Grid item lg={7} md={12} sm={12} xs={12}>
                            <Typography variant="h3" fontWeight={400}>
                                {supplierInvoiceDetail?.supplier?.name}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Stack spacing={0} justifyContent={'end'}>
                                <Typography variant="body1" fontWeight={'500'} fontSize={'24px'} style={{ textAlign: 'end' }}>
                                    {supplierInvoiceDetail?.invoiceNumber}
                                </Typography>
                                {supplierInvoiceDetail?.paymentTerms && supplierInvoiceDetail?.paymentTerms !== 'none' && (
                                    <Typography variant="body1" fontWeight={400} lineHeight={2} className="less-space" style={{ marginTop: '8px' }}>
                                        Payment Terms: {supplierInvoiceDetail?.paymentTerms}
                                    </Typography>
                                )}
                            </Stack>
                        </Grid>
                    </Grid>
                    <Divider style={{ width: '100%' }} />

                    <Grid container item justifyItems={'space-between'} spacing={3}>
                        <Grid item lg={5} md={5} sm={5} xs={12} style={{ display: 'flex', justifyContent: 'start' }}>
                            <Stack gap={'8px'}>
                                <Typography
                                    variant="h6"
                                    fontWeight={'500'}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '4px',
                                        justifyContent: 'flex-start',
                                        lineHeight: '26px',
                                        marginBottom: '4px',
                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                        <path
                                            d="M9.42857 4.79688C9.42857 4.35527 9.04643 4 8.57143 4C8.09643 4 7.71429 4.35527 7.71429 4.79688V6.125H6.28571C5.025 6.125 4 7.07793 4 8.25V18.875C4 20.0471 5.025 21 6.28571 21H17.7143C18.975 21 20 20.0471 20 18.875V8.25C20 7.07793 18.975 6.125 17.7143 6.125H16.2857V4.79688C16.2857 4.35527 15.9036 4 15.4286 4C14.9536 4 14.5714 4.35527 14.5714 4.79688V6.125H9.42857V4.79688ZM5.71429 10.375H18.2857V18.875C18.2857 19.1672 18.0286 19.4062 17.7143 19.4062H6.28571C5.97143 19.4062 5.71429 19.1672 5.71429 18.875V10.375Z"
                                            fill="#006CDD"
                                        />
                                    </svg>{' '}
                                    Date Information
                                </Typography>

                                <Stack direction="row" spacing={2}>
                                    <Typography variant="body1" fontWeight={400} sx={{ width: '153px' }}>
                                        Invoice Date:
                                    </Typography>
                                    <Typography variant="body1" fontWeight={500} sx={{ marginLeft: '20px' }}>
                                        {supplierInvoiceDetail?.supplierInvoiceDate
                                            ? moment(supplierInvoiceDetail.supplierInvoiceDate).format('MMMM D, YYYY')
                                            : '-'}
                                    </Typography>
                                </Stack>

                                <Stack direction="row" spacing={2} sx={{ width: 'max-content' }}>
                                    <Typography variant="body1" fontWeight={400} sx={{ width: '153px' }}>
                                        Parts Ordered Date:
                                    </Typography>
                                    <Typography variant="body1" fontWeight={500} sx={{ marginLeft: '20px' }}>
                                        {supplierInvoiceDetail?.partsOrderedDate ? moment(supplierInvoiceDetail.partsOrderedDate).format('MMMM D, YYYY') : '-'}
                                    </Typography>
                                </Stack>

                                <Stack direction="row" spacing={2} sx={{ width: 'max-content' }}>
                                    <Typography variant="body1" fontWeight={400} sx={{ width: '153px' }}>
                                        Parts Received Date:
                                    </Typography>
                                    <Typography variant="body1" fontWeight={500} sx={{ marginLeft: '20px' }}>
                                        {supplierInvoiceDetail?.partsReceivedDate ? moment(supplierInvoiceDetail.partsReceivedDate).format('MMM D, YYYY') : '-'}
                                    </Typography>
                                </Stack>
                            </Stack>
                        </Grid>
                        <Grid item lg={7} md={7} sm={7} xs={12} style={{ display: 'flex', justifyContent: 'start' }}>
                            <Stack gap={'8px'}>
                                <Typography
                                    variant="h6"
                                    fontWeight={500}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '4px',
                                        justifyContent: 'flex-start',
                                        lineHeight: '26px',
                                        marginBottom: '4px',
                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                        <path
                                            d="M0.75 8H10.5L11.25 9.5H1.5L0.75 8ZM1.75 11H11.5L12.25 12.5H2.5L1.75 11ZM18 19C18.83 19 19.5 18.33 19.5 17.5C19.5 16.67 18.83 16 18 16C17.17 16 16.5 16.67 16.5 17.5C16.5 18.33 17.17 19 18 19ZM19.5 10H17V12.5H21.46L19.5 10ZM8 19C8.83 19 9.5 18.33 9.5 17.5C9.5 16.67 8.83 16 8 16C7.17 16 6.5 16.67 6.5 17.5C6.5 18.33 7.17 19 8 19ZM20 8.5L23 12.5V17.5H21C21 19.16 19.66 20.5 18 20.5C16.34 20.5 15 19.16 15 17.5H11C11 19.16 9.65 20.5 8 20.5C6.34 20.5 5 19.16 5 17.5H3V14H5V15.5H5.76C6.31 14.89 7.11 14.5 8 14.5C8.89 14.5 9.69 14.89 10.24 15.5H15V6.5H3C3 5.39 3.89 4.5 5 4.5H17V8.5H20Z"
                                            fill="#006CDD"
                                        />
                                    </svg>{' '}
                                    Supplier Details
                                </Typography>
                                {supplierInvoiceDetail?.supplier?.name && (
                                    <Stack direction="row" spacing={2}>
                                        <Typography variant="body1" fontWeight={400} sx={{ width: '150px' }}>
                                            Supplier Name
                                        </Typography>
                                        <Typography variant="body1" fontWeight={500} sx={{ marginLeft: '20px' }}>
                                            {supplierInvoiceDetail.supplier.name}
                                        </Typography>
                                    </Stack>
                                )}

                                {supplierInvoiceDetail?.supplier?.account && (
                                    <Stack direction="row" spacing={2}>
                                        <Typography variant="body1" fontWeight={400} sx={{ width: '150px' }}>
                                            Account #
                                        </Typography>
                                        <Typography variant="body1" fontWeight={500} sx={{ marginLeft: '20px' }}>
                                            {supplierInvoiceDetail.supplier.account}
                                        </Typography>
                                    </Stack>
                                )}

                                {supplierInvoiceDetail?.supplier?.phoneNumber && (
                                    <Stack direction="row" spacing={2}>
                                        <Typography variant="body1" fontWeight={400} sx={{ width: '150px' }}>
                                            Phone Number
                                        </Typography>
                                        <Typography variant="body1" fontWeight={500} sx={{ marginLeft: '20px' }}>
                                            {formatPhoneNumber(supplierInvoiceDetail.supplier.phoneNumber)}
                                        </Typography>
                                    </Stack>
                                )}

                                {supplierInvoiceDetail?.supplier?.address && (
                                    <Stack direction="row" spacing={2}>
                                        <Typography variant="body1" fontWeight={400} sx={{ width: '150px' }}>
                                            Address
                                        </Typography>
                                        <Typography variant="body1" fontWeight={500} sx={{ marginLeft: '20px' }}>
                                            {formatPhoneNumber(supplierInvoiceDetail.supplier.address)}
                                        </Typography>
                                    </Stack>
                                )}

                                {supplierInvoiceDetail?.supplier?.primaryEmail && (
                                    <Stack direction="row" spacing={2}>
                                        <Typography variant="body1" fontWeight={400} sx={{ width: '150px' }}>
                                            Email Address
                                        </Typography>
                                        <Typography variant="body1" fontWeight={500} sx={{ marginLeft: '20px' }}>
                                            {formatPhoneNumber(supplierInvoiceDetail.supplier.primaryEmail)}
                                        </Typography>
                                    </Stack>
                                )}

                                {supplierInvoiceDetail?.supplier?.website && (
                                    <Stack direction="row" spacing={2}>
                                        <Typography variant="body1" fontWeight={400} sx={{ width: '150px' }}>
                                            Website
                                        </Typography>
                                        <Typography variant="body1" fontWeight={500} sx={{ marginLeft: '20px' }}>
                                            {formatPhoneNumber(supplierInvoiceDetail.supplier.website)}
                                        </Typography>
                                    </Stack>
                                )}
                            </Stack>
                        </Grid>

                        <Grid item>
                            <Typography variant="h6" fontWeight={'500'}>
                                Total Parts: {supplierInvoiceDetail?.parts?.length}
                            </Typography>
                        </Grid>

                        <Grid container item>
                            <Grid item xl={12} md={12} sm={12} xs={12} boxShadow={0}>
                                {/* shop services table start */}
                                <TableContainer style={{ minWidth: '850px', overflow: 'hidden' }}>
                                    <Table aria-label="caption table" padding="16px">
                                        <TableHead
                                            style={{
                                                backgroundColor: '#f4f6f8',
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            <TableRow style={{ fontWeight: 'bold' }}>
                                                <TableCell align="left" width={80}>
                                                    No.
                                                </TableCell>
                                                <TableCell style={{ width: '300px' }}>Description</TableCell>
                                                <TableCell style={{ width: '300px' }}>Brand/Category</TableCell>
                                                <TableCell width={'120px'} align="right">
                                                    Quantity
                                                </TableCell>
                                                <TableCell width={'120px'} align="right">
                                                    Cost
                                                </TableCell>
                                                <TableCell width={'120px'} align="right">
                                                    Amount
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {supplierInvoiceDetail &&
                                                supplierInvoiceDetail?.parts?.length > 0 &&
                                                supplierInvoiceDetail?.parts?.map((item, index) => {
                                                    return (
                                                        <TableRow key={index}>
                                                            <TableCell component="th" scope="row" width={'120px'}>
                                                                {index + 1}
                                                            </TableCell>
                                                            <TableCell align="left">
                                                                <Box>
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: '14px',
                                                                            fontWeight: 400,
                                                                            letterSpacing: '0.17px',
                                                                            lineHeight: '143%',
                                                                            textDecoration: 'underline',
                                                                            cursor: 'pointer',
                                                                        }}
                                                                        onClick={() => {
                                                                            setSelectedInventoryId(item?.inventory);
                                                                            setBatchNumber(item.batchNumber);
                                                                            setOpenpartModel(true);
                                                                        }}
                                                                    >
                                                                        {item?.part?.partName}
                                                                    </Typography>
                                                                    {(item?.partNumber || item?.tyreDimension) && (
                                                                        <Typography
                                                                            sx={{
                                                                                fontSize: '14px',
                                                                                fontWeight: 400,
                                                                                letterSpacing: '0.17px',
                                                                                lineHeight: '143%',
                                                                                marginTop: '4px',
                                                                            }}
                                                                        >
                                                                            {item?.partNumber || item?.tyreDimension}
                                                                        </Typography>
                                                                    )}
                                                                </Box>
                                                            </TableCell>
                                                            <TableCell align="left" min={548} style={{ padding: '10px 12px' }}>
                                                                {item?.partsBrand?.name && (
                                                                    <Typography
                                                                        padding={0}
                                                                        sx={{
                                                                            color: 'rgba(0, 0, 0, 0.87)',
                                                                            letterSpacing: '0.17px',
                                                                            fontSize: '14px',
                                                                            fontWeight: 400,
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '6px',
                                                                            marginBottom: '4px',
                                                                        }}
                                                                        lineHeight={'normal'}
                                                                    >
                                                                        <BrandSvg />
                                                                        {item.partsBrand.name}
                                                                    </Typography>
                                                                )}
                                                                {item?.partsCategory?.name && (
                                                                    <Typography
                                                                        padding={0}
                                                                        sx={{
                                                                            color: 'rgba(0, 0, 0, 0.87)',
                                                                            letterSpacing: '0.17px',
                                                                            fontSize: '14px',
                                                                            fontWeight: 400,
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '6px',
                                                                            marginBottom: '4px',
                                                                        }}
                                                                        lineHeight={'normal'}
                                                                    >
                                                                        <PartCategorySvg />
                                                                        {item.partsCategory.name}
                                                                    </Typography>
                                                                )}
                                                                {item?.tyreModel?.name && (
                                                                    <Typography
                                                                        padding={0}
                                                                        sx={{
                                                                            color: 'rgba(0, 0, 0, 0.87)',
                                                                            letterSpacing: '0.17px',
                                                                            fontSize: '14px',
                                                                            fontWeight: 400,
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '6px',
                                                                            marginBottom: '4px',
                                                                        }}
                                                                        lineHeight={'normal'}
                                                                    >
                                                                        <PartCategorySvg />
                                                                        {item.tyreModel.name}
                                                                    </Typography>
                                                                )}
                                                            </TableCell>
                                                            <TableCell align="right" width={'120px'}>
                                                                {item?.qty}
                                                            </TableCell>
                                                            <TableCell align="right" width={'120px'}>
                                                                {NumericEngine.format(item?.cost || 0, {
                                                                    formatCurrency: true,
                                                                    trailingZeros: true,
                                                                })}
                                                            </TableCell>
                                                            <TableCell align="right" style={{ paddingRight: '23px' }}>
                                                                {NumericEngine.format(NumericEngine.multiply(item?.qty || 1, item?.cost || 1), {
                                                                    formatCurrency: true,
                                                                    trailingZeros: true,
                                                                })}
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                {/* shop services table ends */}
                            </Grid>
                        </Grid>

                        <Grid container item justifyContent={'end'} padding={'80px 23px 24px 24px'}>
                            <Grid item>
                                <Stack direction="row" spacing={2}>
                                    <Box textAlign={'end'}>
                                        <Typography mb={1}>Sub Total</Typography>
                                        {supplierInvoiceDetail?.discountAmount > 0 && <Typography mb={1}>Discount</Typography>}
                                        <Typography mb={1}>Tax</Typography>
                                        <Typography>Total</Typography>
                                    </Box>
                                    <Box textAlign={'end'}>
                                        <Typography mb={1}>
                                            {NumericEngine.format(supplierInvoiceDetail?.subTotal || 0, {
                                                formatCurrency: true,
                                                trailingZeros: true,
                                            })}
                                        </Typography>

                                        {supplierInvoiceDetail?.discountAmount > 0 && (
                                            <Typography mb={1}>
                                                {NumericEngine.format(supplierInvoiceDetail?.discountAmount || 0, {
                                                    formatCurrency: true,
                                                    trailingZeros: true,
                                                })}
                                            </Typography>
                                        )}

                                        <Typography mb={1}>
                                            {NumericEngine.format(supplierInvoiceDetail?.taxAmount || 0, {
                                                formatCurrency: true,
                                                trailingZeros: true,
                                            })}
                                        </Typography>

                                        <Typography>
                                            {' '}
                                            {NumericEngine.format(supplierInvoiceDetail?.totalAmount || 0, {
                                                formatCurrency: true,
                                                trailingZeros: true,
                                            })}
                                        </Typography>
                                    </Box>
                                </Stack>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>

            <Dialog fullScreen={false} open={showLoader}>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>

            <SuccessMessageModal message={successMessage} open={openSuccessModal} setOpenSuccessModal={setOpenSuccessModal} />

            <CommonDialog
                loader={isDelete}
                dialogClaassName={isUsedInCustomerInvoice ? 'commonDialog__600 commonDialog' : 'commonDialog'}
                open={isOpenDeleteModal}
                onClose={() => {
                    if (!isDelete) {
                        setIsOpenDeleteModal(false);
                    }
                }}
                onSave={async () => {
                    if (isUsedInCustomerInvoice) {
                        setPartInvoiceModal(true);
                        return;
                    }
                    try {
                        setIsDelete(true);
                        let resp = await dispatch(deleteSupplierInvoiceApi(supplierInvoiceDetail?._id));
                        if (resp) {
                            navigate('/suppliers-invoice/all');
                        }
                    } catch (error) {
                    } finally {
                        setIsDelete(false);
                    }
                }}
                dialogTitle={isUsedInCustomerInvoice ? '❌ Cannot Delete Supplier Invoice' : 'Delete Supplier Invoice? '}
                dialogSubtitle={
                    isUsedInCustomerInvoice
                        ? 'Parts from this invoice have already been used in a customer invoice.'
                        : 'Are you sure you want to delete this supplier invoice?'
                }
                dialogSubtitle2={
                    isUsedInCustomerInvoice ? 'To maintain accurate inventory costing and invoicing history, this supplier invoice cannot be deleted.' : ''
                }
                saveButtonType={isUsedInCustomerInvoice ? 'primary' : 'error'}
                saveButtonText={isUsedInCustomerInvoice ? 'View Linked Invoices' : 'Delete'}
                saveButtonWidth={isUsedInCustomerInvoice ? '202px' : '103px'}
            />
            <BatchViewModal
                inventoryId={inventoryOption}
                open={openBatchSelectionModal}
                onClose={() => {
                    setBatchSelectionModal(false);
                }}
                onSave={() => {
                    setBatchSelectionModal(false);
                }}
            />

            <PartUsedInvoiceModal
                open={partInvoiceModal}
                // batchNumber={supplierInvoiceDetail}
                // inventoryId={selectedInventoryId}
                supplierInvoiceId={supplierInvoiceDetail?._id}
                supplierId={supplierInvoiceDetail?.supplier?._id}
                onClose={() => {
                    setPartInvoiceModal(false);
                }}
            />
            <AddInventoryModal
                type={INVENTORY_TYPES.SUPPLIER_INVOICE}
                inventoryId={selectedInventoryId}
                batchNumber={batchNumber}
                viewOnly={true}
                openModal={openPartModel}
                closeModal={() => {
                    setOpenpartModel(false);
                    setSelectedInventoryId(null);
                    setBatchNumber(null);
                }}
                onSubmitModal={() => {
                    setOpenpartModel(false);
                    setSelectedInventoryId(null);
                    setBatchNumber(null);
                }}
                showLoader={false}
                setShowLoader={() => {}}
                selectedInventory={[]}
                setSelectedInventory={() => {}}
                fetchApi={(data) => {}}
                ShowAllTabs={false}
                ShowTabIndex={0}
                modalType={'edit'}
            />
        </Box>
    );
};

export default SupplierSent;
